import { buildApiUrl } from '../../../config/api';

/**
 * Servicio para gestionar leads (suscripciones)
 */
class LeadService {
    /**
     * Suscribir un email a la lista de leads
     * @param {string} email - Email a suscribir
     * @returns {Promise<object>} Resultado de la suscripción
     */
    async subscribeLead(email) {
        try {
            const response = await fetch(buildApiUrl('/api/guest/leads'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({ email }),
            });

            const data = await response.json();

            if (!response.ok) {
                return {
                    success: false,
                    error: data.error || 'Error al suscribirse',
                };
            }

            return {
                success: true,
                message: data.message,
                reactivated: data.reactivated || false,
                alreadySubscribed: data.already_subscribed || false,
            };
        } catch (error) {
            return {
                success: false,
                error: error.message || 'Error de conexión',
            };
        }
    }

    /**
     * Dar de baja un lead usando su token
     * @param {string} token - Token de opt-out
     * @returns {Promise<object>} Resultado del opt-out
     */
    async optOutLead(token) {
        try {
            const response = await fetch(buildApiUrl('/api/guest/leads/opt-out'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({ token }),
            });

            const data = await response.json();

            if (!response.ok) {
                return {
                    success: false,
                    error: data.error || 'Error al cancelar suscripción',
                };
            }

            return {
                success: true,
                message: data.message,
            };
        } catch (error) {
            return {
                success: false,
                error: error.message || 'Error de conexión',
            };
        }
    }
}

// Crear instancia singleton
const leadService = new LeadService();

export default leadService;

